import React from 'react';
import { TextField, Box, TextFieldProps } from '@material-ui/core';
import CustomLabel from './CustomLabel';
import Error from './Error';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ILookupItem } from './type';

interface ISelectFieldProps {
  readonly options: ILookupItem[];
  readonly onChange: (event: any, value: ILookupItem | null) => void;
  readonly value: number | null;
  readonly label?: string;
  readonly required?: boolean;
  readonly error?: boolean;
  readonly nullable?: boolean;
  readonly onInputChange?: (newValue: string) => void;
  readonly disabled?: boolean;
  readonly errorMsg?: string;
  readonly TextFieldProps?: TextFieldProps;
  readonly getOptionDisabled?: (option: ILookupItem) => boolean;
}

const SelectField: React.FunctionComponent<ISelectFieldProps> = ({
  options,
  onChange,
  value,
  label,
  required,
  nullable,
  onInputChange,
  disabled,
  errorMsg,
  TextFieldProps,
  getOptionDisabled
}) => {
  return (
    <Box mb={2}>
      <Autocomplete
        fullWidth
        getOptionDisabled={getOptionDisabled}
        size="small"
        disabled={disabled}
        value={value ? options.find(o => o.id === value) : null}
        options={options}
        onChange={onChange}
        getOptionLabel={option =>
          option.id === -1 ? `Add "${option.label}"` : option.label
        }
        getOptionSelected={(option, value) => option.id === value.id}
        disableClearable={!nullable}
        onInputChange={(event, newValue) =>
          onInputChange && onInputChange(newValue)
        }
        forcePopupIcon={false}
        renderInput={params => (
          <Box>
            {label && (
              <CustomLabel disabled={disabled} required={required}>
                {label}
              </CustomLabel>
            )}
            <Box>
              <TextField
                variant="outlined"
                error={!!errorMsg}
                {...TextFieldProps}
                {...params}
                InputProps={{
                  ...params.InputProps,
                  ...TextFieldProps?.InputProps
                }}
              />
            </Box>
          </Box>
        )}
      />
      <Error errorMsg={errorMsg} />
    </Box>
  );
};
export default SelectField;
